import React, { useEffect, useRef, useState } from 'react';
import ArticleCard from './ArticleCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import observer from '../utils/observer';
import Axios from 'axios';

const Articles = () => {
  const [spin, setSpin] = useState(true);
  const containerRefValue = useRef(null);
  const articlesCardRefValue = useRef(null);
  const [articles, setArticles] = useState([]);
  const [showArticles, setShowArticles] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState(false);
  const [articleImages, setArticleImages] = useState([]);
  const mediumUrl = 'https://api-fitnessspace-zn09.onrender.com/';
  // const mediumUrl =
  //   'https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@fitnessspace.ng';
  // const slicedArticle = articles.slice(0, 5);

  setTimeout(() => {
    setSpin(false);
  }, 2000);

  useEffect(() => {
    observer(containerRefValue, 'section-hidden');
  }, [containerRefValue]);

  useEffect(() => {
    const extractURL = str => {
      const regex = /\bhttps?:\/\/\S+?\.(?:png|jpe?g|gif|bmp|webp)\b/gi;
      const matches = str.match(regex);

      setArticleImages(prev => prev.concat(matches[0]));
    };

    const getBlogs = async mediumUrl => {
      try {
        setIsLoading(true);
        const data = async () => await Axios.get(mediumUrl);
        const response = await data();
        const {
          data: posts
        } = response;
        setArticles(posts);

        posts.map(data => extractURL(data.item['content:encoded']));

        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
      } catch (err) {
        console.error(err.message);
        setErrorMessage(true);
        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
      }
    };

    const loadingBlogs = () => {
      const load = (entries, observer) => {
        const [entry] = entries;

        if (entry.isIntersecting && entry.intersectionRatio > 0) {
          getBlogs(mediumUrl);
          observer.unobserve(entry.target);
        }
      };

      const theObserver = new IntersectionObserver(load, {
        root: null,
        threshold: 0.18,
      });

      theObserver.observe(articlesCardRefValue.current);
    };

    loadingBlogs();
  }, []);
  const showMoreArticles = () => setShowArticles(!showArticles);

  return (
    <div className="article-container section-hidden" ref={containerRefValue}>
      <div className="article-headers">
        <div className="article-header">Articles</div>
        <div className="article-sub-header">
          Check out this quick read that will help you build healthy habits.
        </div>
      </div>
      <div className="articles-container">
        <div className="article-cards" ref={articlesCardRefValue}>
          {isLoading ? (
            <div className="loader">
              <span></span>
              <span></span>
            </div>
          ) : articles?.length === 0 ? (
            <>
              <div className="error-message">
                <span style={{ color: 'red', fontSize: '1.2rem' }}>⚠</span>
                {errorMessage
                  ? ` No Article, Check your network and try again.`
                  : ''}
              </div>
            </>
          ) : (
            articles.map((data, i) => {
              const {
                item: { title, pubDate, link },
              } = data;

              return !showArticles && i > 4 ? (
                ''
              ) : (
                <div key={i}>
                  <ArticleCard
                    articleImage={articleImages[i]}
                    articleName={title}
                    articleDate={pubDate}
                    articleUrl={link}
                  />
                </div>
              );
            })
          )}
          {/* {showArticles ? (
            isLoading ? (
              <div className="loader">
                <span></span>
                <span></span>
              </div>
            ) : (
              articles.map((data, i) => {
                const { thumbnail, title, pubDate, link } = data;

                return articles[4] === data ? (
                  <></>
                ) : (
                  <ArticleCard
                    articleImage={thumbnail}
                    articleName={title}
                    articleDate={pubDate}
                    keyProp={i}
                    articleUrl={link}
                  />
                );
              })
            )
          ) : isLoading ? (
            <div className="loader">
              <span></span>
              <span></span>
            </div>
          ) : articles?.length === 0 ? (
            <>
              <div>{errorMessage}</div>
            </>
          ) : (
            slicedArticle.map((data, i) => {
              const { thumbnail, title, pubDate, link } = data;

              return (
                <ArticleCard
                  articleImage={thumbnail}
                  articleName={title}
                  articleDate={pubDate}
                  keyProp={i}
                  articleUrl={link}
                />
              );
            })
          )} */}
        </div>
        {articles?.length === 0 || isLoading ? (
          <></>
        ) : (
          <div>
            <div className="more-articles-button" onClick={showMoreArticles}>
              <div className="more-articles-button-text">
                See {showArticles ? 'less' : 'more'} articles
              </div>
              <FontAwesomeIcon icon={faArrowRight} spin={spin} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Articles;
